import React, { useMemo } from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";

function BlocksDialog({ open, onClose, blocks }) {
  const groupedBlocks = useMemo(() => {
    if (!open || !Array.isArray(blocks) || blocks.length === 0) return [];

    const acc = {};
    for (const b of blocks) {
      const id = b.shipmentRequestId;
      if (!acc[id]) {
        acc[id] = {
          srId: id,
          srStatus: b.shipmentRequestRecordStatus,
          sis: [],
        };
      }
      if (b.shippingInstructionId) {
        acc[id].sis.push({
          id: b.shippingInstructionId,
          status: b.shippingInstructionStatus || b.shippingInstructionRecordStatus,
        });
      }
    }
    return Object.values(acc);
  }, [open, blocks]);

  if (!open) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Blocked Shipments</DialogTitle>
      <DialogContent>
        {groupedBlocks.length === 0 ? (
          <div>No blocking shipments</div>
        ) : (
          groupedBlocks.map((sr) => (
            <div key={sr.srId} style={{ marginBottom: 8 }}>
              <strong>
                SR: {sr.srId} ({sr.srStatus})
              </strong>
              <ul style={{ marginTop: 4 }}>
                {sr.sis.length > 0 ? (
                  sr.sis.map((si) => (
                    <li key={si.id}>
                      SI: {si.id} ({si.status})
                    </li>
                  ))
                ) : (
                  <li>No SI</li>
                )}
              </ul>
            </div>
          ))
        )}
      </DialogContent>
    </Dialog>
  );
}

export default React.memo(BlocksDialog);
